export default class Roles {
    public static readonly Admin = "Administrator";
    public static readonly Player = "Player";
    public static readonly DemoAdmin = "DemoAdmin";
    public static readonly StatsRunner = "StatsRunner";
}